import request from '@/utils/request'
import base from '@/api/base'

const workbenchApi = {
  getBannerData: base.api + '/motion/web/sand/getBannerData', // 获取沙盘工作台banner位内容
  getProjectList: base.api + '/motion/web/sand/getProjectList', // 获取沙盘工作台项目列表
  addSand: base.api + '/motion/web/sand/add', // 新增沙盘
  renameSand: base.api + '/motion/web/sand/rename', // 重命名沙盘
  copySand: base.api + '/motion/web/sand/copy', // 创建沙盘副本
  deleteSand: base.api + '/motion/web/sand/delete', // 删除沙盘
  publishSand: base.api + '/motion/web/sand/publish', // 发布沙盘模版前置接口
  bicubePublish: base.api + '/family/mall/new/biCube/pulish', // 发布项目/沙盘接口
  sandShare: base.api + '/motion/web/sand/share', // 分享沙盘
  getPageData: base.api + '/motion/web/sand/page/getPageData', // 获取沙盘的页面数据
  openShare: base.api + '/motion/web/sand/page/openShare', // 沙盘分享链接解析
  projectShare: base.api + '/motion/client/project/openShare', // 项目分享链接解析
  queryByTemplateId: base.api + '/family/mall/new/biCube/queryByTemplateId', // 根据模板id查询沙盘
  getSandPropertyData: base.api + '/motion/web/sand/getSandPropertyData', // 获取沙盘属性数据
  getDictData: base.api + '/motion/client/version/getDictData', // 查询字典数据
  saveSandPropertyData: base.api + '/motion/web/sand/saveSandPropertyData', // 保存沙盘属性数据
  saveSandCanvasData: base.api + '/motion/web/sand/saveSandCanvasData', // 保存沙盘画布属性数据
  getLabelList: base.api + '/motion/base/label/list' // 获取标签
}


export const getBannerData = (params) => {
    return request({
        url: workbenchApi.getBannerData,
        method: 'GET',
        params
    })
}

export function getProjectList(data) {
    return request({
        url: workbenchApi.getProjectList, // 请求的URL
        method: 'POST', // 请求的方法
        data // 请求的数据
    })
}

export function addSand(data) {
  return request({
    url: workbenchApi.addSand,
    method: 'POST',
    data
  })
}

export function renameSand(data) {
  return request({
    url: workbenchApi.renameSand,
    method: 'POST',
    data
  })
}

export function copySand(data) {
  return request({
    url: workbenchApi.copySand,
    method: 'POST',
    data
  })
}

export function deleteSand(data) {
  return request({
    url: workbenchApi.deleteSand,
    method: 'POST',
    data
  })
}

export function publishSand(data) {
  return request({
    url: workbenchApi.publishSand,
    method: 'POST',
    data
  })
}

export function bicubePublish(data) {
  return request({
    url: workbenchApi.bicubePublish,
    method: 'POST',
    data
  })
}

export function sandShareApi(data) {
  return request({
    url: workbenchApi.sandShare,
    method: 'POST',
    data
  })
}

export function getPageData(data) {
  return request({
    url: workbenchApi.getPageData,
    method: 'POST',
    data
  })
}

export function openShare(data) {
  return request({
    url: workbenchApi.openShare,
    method: 'POST',
    data
  })
}

// 项目分享链接解析
export function projectShare(data) {
  return request({
    url: workbenchApi.projectShare,
    method: 'POST',
    data
  })
}

export function queryByTemplateId(params) {
  return request({
    url: workbenchApi.queryByTemplateId,
    method: 'GET',
    params
  })
}

//4.3.2 获取沙盘属性数据
export const getSandPropertyDataApi = (data) => {
  return request({
    url: workbenchApi.getSandPropertyData,
    method: 'post',
    data,
  });
};

// 查询字典数据
export function getDictDataApi(data) {
  return request({
    url: workbenchApi.getDictData,
    method: 'post',
    data
  })
}

// 4.3.2 保存沙盘属性数据
export const saveSandPropertyDataApi = (data) => {
  return request({
    url: workbenchApi.saveSandPropertyData,
    method: 'post',
    data,
  });
}

// 4.3.2 保存沙盘画布属性数据
export const saveSandCanvasDataApi = (data) => {
  return request({
    url: workbenchApi.saveSandCanvasData,
    method: 'post',
    data,
  });
}

// 获取标签
export const getLabelListApi = (data) => {
  return request({
    url: workbenchApi.getLabelList,
    method: 'post',
    data,
  });
}

